export interface AvatarAccount {
  name?: string;
  email?: string;
}

// Fixed saturation/lightness keep every result a mid-tone colour: never black
// (L 0) and never white (L 100), with enough contrast for white text on top.
const SATURATION = 55;
const LIGHTNESS = 42;

function hash(seed: string): number {
  let value = 5381;
  for (let index = 0; index < seed.length; index += 1) {
    value = ((value << 5) + value) ^ seed.charCodeAt(index);
  }
  return value >>> 0;
}

export function avatarColor(account: AvatarAccount): string {
  const seed = (account.email || account.name || "").trim().toLowerCase();
  const hue = hash(seed) % 360;
  return `hsl(${hue} ${SATURATION}% ${LIGHTNESS}%)`;
}

// Two-letter monogram: initials of the first and last word, else the first two
// characters. "?" when there's nothing to show.
export function avatarInitials(account: AvatarAccount): string {
  const base = (account.name || account.email || "").trim();
  if (!base) return "?";
  const parts = base.split(/\s+/);
  if (parts.length > 1) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return base.slice(0, 2).toUpperCase();
}
